package pl.decks.chartjs.radar.dataset

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.style.PointStyle

data class PointProperties(
    val backgroundColor: JSScriptableIndexable<ChartColor>,
    val borderColor: JSScriptableIndexable<ChartColor>,
    val borderWidth: JSScriptableIndexable<Int>,
    val hitRadius: JSScriptableIndexable<Int>,
    val radius: JSScriptableIndexable<Int>,
    val rotation: JSScriptableIndexable<Float>,
    val style: JSScriptableIndexable<PointStyle>,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.pointBackgroundColor = backgroundColor.toChartJs { it.toChartJs() }
        this.pointBorderColor = borderColor.toChartJs { it.toChartJs() }
        this.pointBorderWidth = borderWidth.toChartJs { it.asDynamic() }
        this.pointHitRadius = hitRadius.toChartJs { it.asDynamic() }
        this.pointRadius = radius.toChartJs { it.asDynamic() }
        this.pointRotation = rotation.toChartJs { it.asDynamic() }
        this.pointStyle = style.toChartJs { it.toChartJs() }
    }
}
